// extracted by mini-css-extract-plugin
export default {"page":"Booking_page__zvlHt","bg":"Booking_bg__fevOA","wrap":"Booking_wrap__94g1Y","head":"Booking_head__gGY1o","altContact":"Booking_altContact__Capx8"};